import { Zap, RefreshCcw, ShieldCheck, ArrowRight, Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToSection } from "../lib/scroll";
import { DIVISIONE_ASSISTENZA, preselectDivisione } from "../data/divisioni";

const PILLARS = [
    {
        icon: Zap,
        title: "Intervento Rapido nel Sud Italia",
        desc: "Tecnici sul territorio e ricambi originali: interveniamo in media entro 48–72 ore dalla chiamata, riducendo al minimo i fermi impianto.",
    },
    {
        icon: ShieldCheck,
        title: "Controlli Periodici",
        desc: "Eseguiamo verifiche periodiche e manutenzione programmata sulle attrezzature e sugli impianti, con documentazione dei controlli effettuati, secondo le indicazioni dei costruttori e la normativa vigente. Attrezzature sicure, efficienti e in regola.",
    },
    {
        icon: RefreshCcw,
        title: "Manutenzione Programmata",
        desc: "Piani di manutenzione programmata concordati con il cliente: interventi pianificati, ricambi originali e report dettagliati, per impianti sempre efficienti.",
    },
];

export const Assistenza = () => (
    <section
        id="assistenza"
        data-testid="assistenza-section"
        className="relative overflow-hidden bg-[#0B1F3A] py-20 lg:py-28"
    >
        <div
            aria-hidden="true"
            className="pointer-events-none absolute -left-32 top-0 h-96 w-96 rounded-full bg-[#E30613]/10 blur-3xl"
        />
        <div
            aria-hidden="true"
            className="pointer-events-none absolute -right-32 bottom-0 h-96 w-96 rounded-full bg-white/[0.04] blur-3xl"
        />

        <div className="relative mx-auto max-w-[1440px] px-4 sm:px-8 lg:px-16">
            <div className="max-w-2xl">
                <Reveal>
                    <span className="text-xs font-bold uppercase tracking-[0.22em] text-[#E30613]">
                        Assistenza tecnica
                    </span>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="font-display mt-4 text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
                        Quando un impianto si ferma, noi siamo già in strada.
                    </h2>
                </Reveal>
                <Reveal delay={0.18}>
                    <p className="mt-5 text-base leading-relaxed text-white/70 sm:text-lg">
                        L'assistenza post-vendita è il nostro vero punto di forza: presenza diretta
                        sul territorio, ricambi originali e tecnici formati dai
                        costruttori.
                    </p>
                </Reveal>
            </div>

            <div className="mt-14 grid gap-6 md:grid-cols-3" data-testid="assistenza-pillars">
                {PILLARS.map((p, i) => (
                    <Reveal key={p.title} delay={0.08 + i * 0.09}>
                        <article
                            data-testid={`assistenza-pillar-${i}`}
                            className="group h-full rounded-3xl border border-white/10 bg-white/[0.05] p-8 backdrop-blur-sm transition-[background-color,transform,border-color] duration-500 hover:-translate-y-1.5 hover:border-[#E30613]/40 hover:bg-white/[0.08]"
                        >
                            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#E30613] transition-transform duration-500 group-hover:scale-110">
                                <p.icon className="h-7 w-7 text-white" strokeWidth={1.8} />
                            </div>
                            <h3 className="font-display mt-6 text-xl font-bold text-white">
                                {p.title}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-white/65">{p.desc}</p>
                        </article>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.2}>
                <div
                    data-testid="assistenza-cta-box"
                    className="mt-12 flex flex-col items-start justify-between gap-6 rounded-3xl border border-[#E30613]/30 bg-gradient-to-r from-[#E30613]/15 to-transparent p-8 sm:flex-row sm:items-center lg:p-10"
                >
                    <div>
                        <div className="font-display text-xl font-extrabold text-white sm:text-2xl">
                            Impianto fermo? Parliamone subito.
                        </div>
                        <div className="mt-2 text-sm text-white/70 sm:text-base">
                            Chiamaci al{" "}
                            <a
                                href="tel:+390984443552"
                                className="font-bold text-white underline decoration-[#E30613] decoration-2 underline-offset-4 transition-colors hover:text-[#E30613]"
                                data-testid="assistenza-phone-link"
                            >
                                0984 443552
                            </a>{" "}
                            o vieni a trovarci: Via Icaro, 2 — 87040 Castrolibero (CS).
                        </div>
                    </div>
                    <div className="flex shrink-0 flex-col gap-3 sm:flex-row">
                        <a
                            data-testid="assistenza-call-button"
                            href="tel:+390984443552"
                            className="flex items-center justify-center gap-2.5 rounded-full border-2 border-white/25 px-8 py-4 text-base font-bold text-white transition-[background-color,border-color] duration-300 hover:border-white hover:bg-white/10"
                        >
                            <Phone className="h-5 w-5" />
                            Chiama Ora
                        </a>
                        <button
                            data-testid="assistenza-cta-button"
                            onClick={() => { preselectDivisione(DIVISIONE_ASSISTENZA); scrollToSection("contatti"); }}
                            className="group flex items-center justify-center gap-2.5 rounded-full bg-[#E30613] px-8 py-4 text-base font-bold text-white transition-[background-color,transform] duration-300 hover:bg-[#C20410] active:scale-95"
                        >
                            Richiedi Intervento
                            <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
                        </button>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);
